import { overloadMaybe } from '@simplisafe/ewok'
import { selectCustomerGroupKey } from '@simplisafe/ss-ecomm-data/cart/select'
import { useSelector } from 'react-redux'

export const useCustomerGroupKey = () => {
  const cartCustomerGroup = useSelector(selectCustomerGroupKey)
  return overloadMaybe(cartCustomerGroup)
}
